module.exports = __webpack_public_path__ + "img/MEDIA091.2ba32412.jpg";